import { AppError } from '@mews-framework/errors';
import { SAFE_CONTEXT_INITIAL_VALUE, SafeContextInitialValue } from './constants';

export const returnContextValueOrThrow = <T extends {}>(
    contextValue: T | SafeContextInitialValue,
    contextName = ''
): T => {
    if (contextValue === SAFE_CONTEXT_INITIAL_VALUE) {
        throw new AppError(`Context ${contextName} is not initialized`);
    }
    return contextValue;
};

export const createConsumerWithSafeGuard =
    <T extends {}>({
        Consumer,
        displayName,
    }: React.Context<T | SafeContextInitialValue>): React.FC<{ children: (v: T) => React.ReactElement }> =>
    ({ children }) => (
        <Consumer>
            {(value) => {
                const v = returnContextValueOrThrow(value, displayName);
                return children(v);
            }}
        </Consumer>
    );
